import styled from 'styled-components';
import TableOfContentSidebar from '@/components/TableOfContentSidebar';

export const Sidebar = styled(TableOfContentSidebar)`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    top: 67px;
  }
`;

export const Content = styled.div`
  & > div:first-of-type {
    z-index: 1;
  }
  width: 100%;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: calc(100% - 300px);
  }
`;

export const PageGrid = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    flex-direction: row;
  }
`;
